module.exports = __webpack_public_path__ + "static/media/hazard-event.8e691615.svg";